<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
  <p *ngIf="data.help">{{ data.help }}</p>
  <shared-form-editor [config]="config"></shared-form-editor>
</div>
